import React from 'react'
import {BsInfoCircleFill} from 'react-icons/bs'
import PageHeaderComponent from '../../components/pageHeader'
import './styles.scss'

import App from '../../utils/Contact'

const Contact = () => {
    return (
        <section id="contact" className='contact'>
            <PageHeaderComponent 
                headerText="Contact me"
                icon={<BsInfoCircleFill size={40}/>}
            />
            {App()}
        </section>
    )
}

export default Contact;